module.exports = __webpack_public_path__ + "static/media/bell-on.a1e81041.svg";